import {
  DenmarkFlagIcon,
  EstoniaFlagIcon,
  FinlandFlagIcon,
  GermanyFlagIcon,
  PolandFlagIcon,
  UnitedKingdomFlagIcon,
  SwedishFlagIcon
} from '@kvdbil/components';
import { Locale } from '~/App/shared/localization/types';
import React from 'react';
import { GroupBase } from 'react-select';

// Width of the menu drawer (kept in px: easier to reason about at this size).
// Shared by the Drawer component and the language-select dropdown so the
// expanded list lines up with the drawer column.
export const MENU_DRAWER_WIDTH = '425px';

export type Country = {
  value: Locale;
  label: string;
  icon: React.ReactNode;
};

export const countriesWithoutSweden: Country[] = [
  {
    value: 'et',
    label: 'Eesti keel',
    icon: <EstoniaFlagIcon />
  },
  {
    value: 'en',
    label: 'English',
    icon: <UnitedKingdomFlagIcon />
  },
  {
    value: 'pl',
    label: 'Polski',
    icon: <PolandFlagIcon />
  },
  {
    value: 'fi',
    label: 'Suomi',
    icon: <FinlandFlagIcon />
  },
  {
    value: 'de',
    label: 'Deutsch',
    icon: <GermanyFlagIcon />
  },
  {
    value: 'da',
    label: 'Dansk',
    icon: <DenmarkFlagIcon />
  }
];

export const countries: Country[] = [
  {
    value: 'sv',
    label: 'Svenska',
    icon: <SwedishFlagIcon />
  },
  {
    // Domestic English on kvd.se (served behind /en/). Distinct from the `en`
    // export locale on kvdcars.com; the two are told apart in the switcher by
    // their group ("Within Sweden" vs "Export").
    value: 'en-SE',
    label: 'English',
    icon: <UnitedKingdomFlagIcon />
  },
  ...countriesWithoutSweden
];

/**
 * Builds a react-select option group for the language switchers from a list of
 * locales, alphabetised by label. Locales with no matching `Country` entry are
 * skipped. Shared by LanguageSelect and LanguageSelectModal so their grouping
 * and ordering stay in sync.
 */
export const buildCountryGroup = (
  label: string,
  locales: Locale[]
): GroupBase<Country> => ({
  label,
  options: locales
    .map(locale => countries.find(country => country.value === locale))
    .filter((country): country is Country => Boolean(country))
    .sort((a, b) => a.label.localeCompare(b.label, 'sv'))
});
